// Shell mobile Life — détection du contexte « app » (design V3 validé,
// cf. DEV/mockup_mobile_navigation_v3.html).
// Le shell mobile (header + tab bar flottante + FAB) remplace la NavBar
// desktop quand :
//   - on tourne dans la WebView native Capacitor (iOS / Android), ou
//   - la fenêtre est étroite (≤ 768 px) — utile pour tester dans Chrome
//     en mode responsive sans builder l'app.
import { useEffect, useState } from 'react'
import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

export const MOBILE_SHELL_BREAKPOINT = 768

// À appeler une fois au démarrage (App.js) : barre d'état en texte clair
// sur nos fonds sombres, dès l'écran de login. No-op hors natif.
export function initNativeUi() {
  if (!isNativeApp()) return
  StatusBar.setStyle({ style: Style.Dark }).catch(() => {})
  if (Capacitor.getPlatform() === 'android') {
    StatusBar.setBackgroundColor({ color: '#0b0e1a' }).catch(() => {})
  }
}

export function isNativeApp() {
  try {
    return Capacitor.isNativePlatform()
  } catch (_) {
    return false
  }
}

export function useIsMobileShell() {
  const [isMobile, setIsMobile] = useState(
    () => isNativeApp() || window.innerWidth <= MOBILE_SHELL_BREAKPOINT,
  )

  useEffect(() => {
    if (isNativeApp()) return undefined // natif : toujours mobile, pas de listener
    const onResize = () =>
      setIsMobile(window.innerWidth <= MOBILE_SHELL_BREAKPOINT)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return isMobile
}
